import { MessageGroup, useMessageGroupCountQuery } from "../../../Utilities";
import { viewerMessageGroupFilter } from "./filters";

export function useIsViewerInMessageGroup(messageGroupID: MessageGroup["id"]) {
	const { loading, data } = useMessageGroupCountQuery({
		variables: {
			filters: {
				and: [{ idEQ: messageGroupID }, viewerMessageGroupFilter],
			},
		},
	});
	const isViewerInMessageGroup = !!data && data.messageGroupConnection.totalCount > 0;

	return {
		loading,
		isViewerInMessageGroup,
	};
}
